import { ClarificationModeFields } from '@/components/clarification-mode-fields';
import { useClarificationPrefsStore } from '@/stores/clarification-prefs-store';

import { CustomInstructionsForm } from './custom-instructions-popover';

/** Whether anything here is set, for the "+" menu's indicator dot. */
export function useChatSettingsActive(
  customInstructions: string,
  clarificationSettingsEnabled: boolean,
): boolean {
  const mode = useClarificationPrefsStore(
    (state) => state.workflowSession?.mode ?? state.mode,
  );
  return (
    Boolean(customInstructions) ||
    (clarificationSettingsEnabled && mode !== 'auto')
  );
}

interface ChatSettingsContentProps {
  customInstructionsEnabled: boolean;
  clarificationSettingsEnabled: boolean;
  customInstructions: string;
  onSaveCustomInstructions: (value: string) => void;
  /** Called after Save or Clear so the hosting popover can close. */
  onDone: () => void;
}

export function ChatSettingsContent({
  customInstructionsEnabled,
  clarificationSettingsEnabled,
  customInstructions,
  onSaveCustomInstructions,
  onDone,
}: ChatSettingsContentProps) {
  const isWorkflowScoped = useClarificationPrefsStore(
    (state) => state.workflowSession !== null,
  );

  return (
    <div className='space-y-4'>
      {clarificationSettingsEnabled && (
        <section className='space-y-3'>
          <div>
            <h4 className='text-sm font-medium'>Clarifying questions</h4>
            <p className='mt-0.5 text-xs text-muted-foreground'>
              Choose how agents proceed when they need more information during a
              workflow run.
            </p>
            {isWorkflowScoped && (
              <p className='mt-1 text-xs text-muted-foreground'>
                Changes apply to this workflow session only.
              </p>
            )}
          </div>

          <ClarificationModeFields idPrefix='chat-settings-clarification' />
        </section>
      )}

      {customInstructionsEnabled && (
        <section
          className={
            clarificationSettingsEnabled
              ? 'space-y-3 border-t pt-4'
              : 'space-y-3'
          }
        >
          <CustomInstructionsForm
            customInstructions={customInstructions}
            onSave={onSaveCustomInstructions}
            onDone={onDone}
          />
        </section>
      )}
    </div>
  );
}
